import { AxiosRequestConfig } from 'axios'
import { AffiliateAdminPhotoType } from 'components/Admin/DirectoryPage/ImageModal'
import { createRequestInstance } from 'services'
import { AffiliateImages } from 'types'

export const AFFILIATES_URL = import.meta.env.VITE_AFFILIATES_URL || ''

const request = createRequestInstance({
  baseURL: AFFILIATES_URL,
})

export async function uploadAffiliatePhoto(
  type: AffiliateAdminPhotoType,
  id: number,
  image: File,
  userId: number,
  onUploadProgress: AxiosRequestConfig['onUploadProgress'],
) {
  const url = `${AFFILIATES_URL}/affiliates/${id}/images/upload()`
  const formData = new FormData()

  formData.append('type', type)
  formData.append('file', image)

  if (userId) {
    formData.append('user_id', userId.toString())
  }

  const { data } = await request.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress,
  })

  return data as unknown as AffiliateImages
}
